import { extendVariants, Input } from "@nextui-org/react";

const SpicyInput = extendVariants(Input, {
  variants: {
    default: {
      custom: {
        input: "focus:placeholder:opacity-0",
        base: "focus-within:translate-y-[-2px] transition-all",
        inputWrapper: "shadow-none group-data-[focus=true]:shadow-small transition-opacity delay-150",
        clearButton: "!flex p-0 bg-transparent relative",
      },
    },
    isReadOnly: {
      true: {
        base: "focus-within:translate-y-0",
      },
    },
    variant: {
      primary: {
        base: "h-[44px]",
        inputWrapper: "h-full rounded-[14px]",
        input: "text-[16px]",
      },
      primary_bordered: {
        base: "h-[44px] border-2 border-solid border-gray-400 rounded-2xl px-[6px] rounded-[14px]",
        inputWrapper: "h-full group-data-[focus=true]:shadow-none",
        input: "text-[14px]",
      },
      primary_small: {
        base: "w-[200px] h-[44px]",
        inputWrapper: "h-full rounded-[14px]",
        input: "text-[16px]",
      },
      primary_small_short: {
        base: "w-[179px] h-[40px]",
        inputWrapper: "h-full rounded-[12px]",
        input: "text-[16px]",
      },
      primary_underlined: {
        base: "max-w-full min-w-[140px] h-[40px] focus-within:translate-y-0",
        inputWrapper:
          "h-full min-h-full rounded-none transition-background border-2 border-solid border-l-0 border-t-0 border-r-0 border-gray-200 !duration-150 group-data-[focus=true]:shadow-none after:content-[''] after:w-0 after:origin-center after:bg-default-foreground after:absolute after:left-1/2 after:-translate-x-1/2 after:-bottom-[2px] after:h-[2px] group-data-[focus=true]:after:w-full after:transition-width px-2",
        input: "text-[14px] !pl-0",
        clearButton: "pt-3.5 px-1",
      },

      secondary: {
        base: "min-w-[192px] min-h-[35px] max-h-[35px] relative",
        inputWrapper: "min-h-full h-full rounded-[8px] absolute",
        input: "text-[12px]",
      },
      secondary_bordered: {
        base: "min-w-[192px] min-h-[35px] max-h-[35px] overflow-hidden relative rounded-full border-1 border-solid mx-auto",
        inputWrapper: "min-h-full h-full rounded-[8px] ",
        input: "text-[14px]",
      },
      secondary_underlined: {
        base: "max-w-[179px] min-w-[140px] h-[32px] focus-within:translate-y-0",
        inputWrapper:
          "h-full min-h-full rounded-none transition-background border-2 border-solid border-l-0 border-t-0 border-r-0 border-gray-200 !duration-150 group-data-[focus=true]:shadow-none after:content-[''] after:w-0 after:origin-center after:bg-default-foreground after:absolute after:left-1/2 after:-translate-x-1/2 after:-bottom-[2px] after:h-[2px] group-data-[focus=true]:after:w-full after:transition-width px-2",
        input: "text-[12px] ml-1.5 !pl-0",
        clearButton: "pt-3.5 px-1",
      },
      tertiary: {
        base: "w-[110px] min-h-[28px] max-h-[28px]",
        inputWrapper:
          "min-h-full h-full rounded-[8px] border-2 border-solid border-gray-400 data-[hover=true]:border-gray-400 group-data-[focus=true]:border-gray-400",
        input: "text-[12px]",
      },
    },
    color: {
      primary: {
        inputWrapper: "bg-gray-50 data-[hover=true]:bg-gray-50 group-data-[focus=true]:bg-gray-50",
      },
      secondary: {
        inputWrapper:
          "bg-white data-[hover=true]:bg-white group-data-[focus=true]:bg-white dark:bg-gray-50 dark:data-[hover=true]:bg-gray-50 dark:group-data-[focus=true]:bg-gray-50",
      },
      tertiary: {
        inputWrapper: "!bg-[#222222] border-1 border-solid border-[#0072F580]",
      },
      transparent: {
        inputWrapper: "bg-transparent data-[hover=true]:bg-transparent group-data-[focus=true]:bg-transparent",
      },
    },
  },
  defaultVariants: {
    default: "custom",
  },
});

export default SpicyInput;
